export default "__VITE_ASSET__aF902pwy__"